import { Link } from 'react-router-dom';
import type { BlogPost } from '../../data/blog';
import { formatBlogDate } from '../../data/blog';

interface BlogPostCardProps {
  post: BlogPost;
  index: number;
}

export function BlogPostCard({ post, index }: BlogPostCardProps) {
  return (
    <article
      className="blog-card blog-card--featured reveal-item"
      style={{ transitionDelay: `${index * 0.07}s` }}
    >
      <Link to={`/blog/${post.slug}`} className="blog-card__link">
        <div className="blog-card__media">
          <img src={post.image} alt="" loading="eager" className="blog-card__image" />
        </div>

        <div className="blog-card__body">
          <div className="blog-card__meta">
            <span className="blog-card__category">{post.category}</span>
            <span className="blog-card__dot" aria-hidden />
            <time dateTime={post.date}>{formatBlogDate(post.date)}</time>
          </div>
          <h2 className="blog-card__title">{post.title}</h2>
          <p className="blog-card__excerpt">{post.excerpt}</p>
          <span className="blog-card__cta">
            Read
            <svg viewBox="0 0 16 16" aria-hidden className="blog-card__arrow">
              <path
                fill="currentColor"
                d="M3 8h8.59L8.29 4.71 9.71 3.29 14.41 8l-4.7 4.71-1.42-1.42L11.59 9H3V8z"
              />
            </svg>
          </span>
        </div>
      </Link>
    </article>
  );
}
